// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 239) return "blog.2.1.2.bundle.css";
	// return url for filenames based on template
	return "" + {"95":"pajination","710":"blogpostContent","956":"scrollToTop","977":"swiperCarousel"}[chunkId] + "." + {"95":"04daf8a34ad3b5628be8","710":"227cd11b154bb1a516c4","956":"b755cbaadea41c2b034f","977":"98a251e674d1fa158a18"}[chunkId] + ".css";
};